import { Component, Inject, OnInit, isDevMode } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FirebaseService } from '../../service/firebase.service';

@Component({
  selector: 'app-list-select-device',
  templateUrl: './list-select-device.component.html',
  styleUrls: ['./list-select-device.component.scss']
})
export class ListSelectDeviceComponent implements OnInit {
  public listDevice;
  public selectedOptions;
  public enable: boolean = true ;
  constructor(private _firebase: FirebaseService, public dialogRef: MatDialogRef<ListSelectDeviceComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
  //  console.log(this.currentDevice, data)
  }

  ngOnInit(): void {
    this._firebase.getAllDevicesFromUser().then(d => {
      this.listDevice = d.map(v => {
     //   v.data.id = v.id

        return v//.data
      }

      )
      this.listDevice = this.listDevice.filter(v => 
        v.id != this.data.selectedDevice.id
    )

    })





  }

  selectedAllOptions() {
    this.selectedOptions = this.listDevice;
  }


  setSelectedDevice(data): void {
    console.log(this.selectedOptions)

    /* this.data.inputData = data;*/
    this.dialogRef.close(this.selectedOptions);
  }

}
